module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: Ticket ใหม่","page.description":"เปิด Ticket ใหม่ เพื่อสอบถาม หรือ ปรึกษาการเคลมสำหรับ Drone ตัวนี้","ticket_create.confirm.title":"ยืนยันการเปิด Ticket","ticket_create.confirm.message":"คุณต้องการยืนยันการเปิด Ticket ตัวนี้ ?","ticket_create.success":"เปิด Ticket เรียบร้อยด้วย เลข Ticket {ticket}","ticket_create.submit.label":"เปิด Ticket"}}')
  delete Component.options._Ctor
}
